module.exports = __webpack_public_path__ + "static/media/search_icon.57077e06.png";